module.exports = __webpack_public_path__ + "static/media/Climatizacion.43d0fff5.png";